module.exports = __webpack_public_path__ + "img/secure-pay-icon.57ad2c7f.svg";